import React, { useState, useEffect } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';

import { IconButton } from '@material-ui/core';
import { Fullscreen, FullscreenExit } from '@material-ui/icons';

import api from '~/services/api';

import VisaoGeral from '../VisaoGeral';
import * as S from './styles';

export default function DashboardVisaoGeralFullscreen() {
  const handle = useFullScreenHandle();

  return (
    <FullScreen handle={handle}>
      <S.WrapperFullScreen>
        <VisaoGeral
          headerIcon={
            <IconButton
              aria-label={
                handle.active
                  ? 'Fechar janela em tela cheia'
                  : 'Abrir janela em tela cheia'
              }
              onClick={() => (handle.active ? handle.exit() : handle.enter())}
            >
              {handle.active ? <FullscreenExit /> : <Fullscreen />}
            </IconButton>
          }
        />
      </S.WrapperFullScreen>
    </FullScreen>
  );
}
